import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DisplayTemplateDto } from '../../../../../api/gen';
import { DisplayState } from '../../../../../api/gen/model/displayState';

@Component({
  selector: 'app-state-list',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './state-list.component.html',
  styleUrl: './state-list.component.scss'
})
export class StateListComponent {
  @Input() allStates: DisplayState[] = [];
  @Input() template: DisplayTemplateDto | null = null;
  @Input() selectedState: DisplayState | null = null;
  @Output() stateSelected = new EventEmitter<DisplayState>();
  @Output() removeLayout = new EventEmitter<DisplayState>();

  hasStateLayout(state: DisplayState): boolean {
    return !!this.template?.stateLayouts?.some(l => l.state === state);
  }

  getSlotCountLabel(state: DisplayState): string {
    const layout = this.template?.stateLayouts?.find(l => l.state === state);
    const layerCount = layout?.layers?.length ?? 0;
    if (layerCount > 0) {
      return `${layerCount} layer${layerCount === 1 ? '' : 's'}`;
    }
    const count = layout?.slots?.length ?? 0;
    return `${count} slot${count === 1 ? '' : 's'}`;
  }
}
